import styled from "styled-components";

export const MusicHallTableContainerStyled = styled.div`
  .btn_create {
    margin-top: 20px;
    margin-bottom: 22px;
    display: flex;
    justify-content: flex-end;
  }
  .table_wrap {
    &.is_fullscreen {
      position: fixed;
      inset: 0;
      z-index: 90; /* ต่ำกว่า Modals.Alert (99) / BGLoading + toast (9999) ให้ป๊อปอัพยังโผล่ทับได้ */
      box-sizing: border-box;
      padding: 20px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      display: flex;
      flex-direction: column;
      overflow: hidden;
      > * {
        flex: 1;
        min-height: 0;
      }
    }
  }
`;
